import { Router } from "@angular/router";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "./../../../environments/environment";
import { Injectable } from "@angular/core";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { removeNullishFieldsParams } from "../../shared/object_helpers";

@Injectable()
export class HelpdeskService {
  baseUrl: string = environment.api_base_url;
  constructor(
    private http: HttpClient,
    private ngxLoaderService: NgxUiLoaderService,
    private router: Router
  ) { }

  addTicket(payload) {
    return this.http.post(
      `${this.baseUrl}helpdesk/tickets`,
      JSON.stringify(payload)
    );
  }

  editTicket(payload, ticketId) {
    return this.http.put(
      `${this.baseUrl}helpdesk/tickets/${ticketId}`,
      JSON.stringify(payload)
    );
  }

  getTickets(qParam?: { is_resolved?: "true"; title? }) {
    return this.http.get(`${this.baseUrl}helpdesk/tickets`, { params: qParam });
  }

  getTicketDetails(id) {
    return this.http.get(`${this.baseUrl}helpdesk/tickets/${id}`);
  }

  getTicketDetailsFeedbacks(id) {
    return this.http.get(`${this.baseUrl}helpdesk/tickets/${id}/feedbacks`);
  }
  
  exportTickets(params = {}) {
    params = removeNullishFieldsParams(params);
    return this.http.get(`${this.baseUrl}helpdesk/tickets`, {
      params
    })
  }

  getTicketClientRequests() {
    return this.http.get(`${this.baseUrl}ticket-client-requests`);
  }

  assignTicketToAgent(id, payload) {
    this.ngxLoaderService.start();
    return this.http.put(
      `${this.baseUrl}helpdesk/tickets/${id}/assign`,
      payload
    );
  }

  addFeedbackToTicket(id, payload) {
    this.ngxLoaderService.start();

    return this.http.post(
      `${this.baseUrl}helpdesk/tickets/${id}/feedbacks`,
      payload
    );
  }

  requestApprovalForATicket(id, payload) {
    this.ngxLoaderService.start();

    return this.http.post(
      `${this.baseUrl}helpdesk/tickets/${id}/request_approval`,
      payload
    );
  }

  resolveTicketApprovalRequest(ticket_id, req_id, payload) {
    this.ngxLoaderService.start();

    return this.http.put(
      `${this.baseUrl}helpdesk/tickets/${ticket_id}/request_approval/${req_id}`,
      payload
    );
  }

  changeTicketStatus(id, payload) {
    this.ngxLoaderService.start();

    return this.http.put(
      `${this.baseUrl}helpdesk/tickets/${id}/changeStatus`,
      payload
    );
  }

  getsUsersToAssignTicket() {
    return this.http.get(`${this.baseUrl}helpdesk/assignable_users`);
  }

  markTicketAsResolved(id) {
    return this.http.put(
      `${this.baseUrl}helpdesk/tickets/${id}/markAsResolved`,
      {}
    );
  }

  markTicketAsFinished(id) {
    return this.http.put(
      `${this.baseUrl}helpdesk/tickets/${id}/markAsFinished`,
      {}
    );
  }

  getTicketTypes() {
    return this.http.get(`${this.baseUrl}ticketTypes`);
  }

  getTicketSource() {
    return this.http.get(`${this.baseUrl}ticketSources`);
  }

  getTicketPriority() {
    return this.http.get(`${this.baseUrl}ticketPriorities`);
  }

  getTicketStatus() {
    return this.http.get(`${this.baseUrl}ticketStatus`);
  }

  addTicketTypes(payload) {
    return this.http.post(
      `${this.baseUrl}ticketTypes`,
      JSON.stringify(payload)
    );
  }

  addTicketSource(payload) {
    return this.http.post(
      `${this.baseUrl}ticketSources`,
      JSON.stringify(payload)
    );
  }

  addTicketPriority(payload) {
    return this.http.post(
      `${this.baseUrl}ticketPriorities`,
      JSON.stringify(payload)
    );
  }

  addTicketStatus(payload) {
    return this.http.post(
      `${this.baseUrl}ticketStatus`,
      JSON.stringify(payload)
    );
  }

  editTicketTypes(id, payload) {
    return this.http.put(
      `${this.baseUrl}ticketTypes/${id}`,
      JSON.stringify(payload)
    );
  }

  editTicketSource(id, payload) {
    return this.http.put(
      `${this.baseUrl}ticketSources/${id}`,
      JSON.stringify(payload)
    );
  }

  editTicketPriority(id, payload) {
    return this.http.put(
      `${this.baseUrl}ticketPriorities/${id}`,
      JSON.stringify(payload)
    );
  }

  editTicketStatus(id, payload) {
    return this.http.put(
      `${this.baseUrl}ticketStatus/${id}`,
      JSON.stringify(payload)
    );
  }

  deleteTicketTypes(id) {
    return this.http.delete(`${this.baseUrl}ticketTypes/${id}`);
  }

  deleteTicketSource(id) {
    return this.http.delete(`${this.baseUrl}ticketSources/${id}`);
  }

  deleteTicketPriority(id) {
    return this.http.delete(`${this.baseUrl}ticketPriorities/${id}`);
  }

  deleteTicketStatus(id) {
    return this.http.delete(`${this.baseUrl}ticketStatus/${id}`);
  }

  deleteTicketClientRequests(id) {
    return this.http.delete(`${this.baseUrl}ticket-client-requests/${id}`);
  }

  addTicketClientRequests(payload) {
    return this.http.post(
      `${this.baseUrl}ticket-client-requests`,
      JSON.stringify(payload)
    );
  }

  editTicketClientRequests(id, payload) {
    return this.http.put(
      `${this.baseUrl}ticket-client-requests/${id}`,
      JSON.stringify(payload)
    );
  }


  reopenTicket(id) {
    return this.http.put(`${this.baseUrl}helpdesk/tickets/${id}/reopen`, {});
  }

  getTicketActivities(id) {
    return this.http.get(`${this.baseUrl}helpdesk/tickets/${id}/activities`);
  }

  getUserDepartments(id = null, is_for_head_assign = null) {
    return this.http.get(`${this.baseUrl}users/departments`, {
      params: {
        department_id: id || "",
        for_head_assign: is_for_head_assign || "",
      },
    });
  }

  addDepartment(payload) {
    return this.http.post(
      `${this.baseUrl}departments`,
      JSON.stringify(payload)
    );
  }

  getDepartments() {
    return this.http.get(`${this.baseUrl}departments`);
  }

  getApprovalRequestDepartments() {
    return this.http.get(`${this.baseUrl}helpdesk/approval/departments`);
  }

  getDepartment(id) {
    return this.http.get(`${this.baseUrl}departments/${id}`);
  }

  getTicketReservations(id) {
    return this.http.get(`${this.baseUrl}helpdesk/tickets/${id}/edit`);
  }

  editDepartment(id, payload) {
    return this.http.put(
      `${this.baseUrl}departments/${id}`,
      JSON.stringify(payload)
    );
  }

  /**
   * opens lead page
   */
  viewLead(leadId: number, readonly: boolean = true) {
    const ro = readonly ? 1 : 0;
    let url = this.router.serializeUrl(
      this.router.createUrlTree([`/pages/leads/${leadId}`], {
        queryParams: { ro: ro },
      })
    );
    // if (!environment.base_url || environment.base_url.length == 0) {
    //   url = this.router.serializeUrl(
    //     this.router.createUrlTree([`/pages/leads/${leadId}`], {
    //       queryParams: { ro: ro },
    //     })
    //   );
    // } else {
    //   if (
    //     window.location.href.includes("https://staging2.fabrica-dev.com/castle")
    //   ) {
    //     url = `https://staging2.fabrica-dev.com/castle/pages/leads/${leadId}?ro=${ro}`;
    //   } else {
    //     url = `https://system.castle-development.com/pages/leads/${leadId}?ro=${ro}`;
    //   }
    //   // url = environment.base_url + `/pages/leads/${leadId}?ro=${ro}`
    // }
    window.open(url, "_blank");
  }

  /**
   * opens reservation page
   */
  viewReservation(reservationId: number, readonly: boolean = true) {
    // const ro = readonly? 1 : 0;
    // let url = '';
    // if( !environment.base_url || environment.base_url.length == 0){
    //   url = this.router.serializeUrl(
    //     this.router.createUrlTree([`/pages/leads/${leadId}`], { queryParams: { ro: ro } })
    //   );
    // }
    // else{
    //   if (window.location.href.includes('https://staging2.fabrica-dev.com/castle')) {
    //     url = `https://staging2.fabrica-dev.com/castle/pages/leads/${leadId}?ro=${ro}`
    //   } else {
    //     url = `https://system.castle-development.com/pages/leads/${leadId}?ro=${ro}`
    //   }
    //   // url = environment.base_url + `/pages/leads/${leadId}?ro=${ro}`
    // }
    // window.open(url, '_blank');

    // window.location.hostname
    const ro = readonly ? 1 : 0;
    let url = this.router.serializeUrl(
      this.router.createUrlTree(
        [`/pages/project/view-reservation/${reservationId}`],
        { queryParams: { ro: ro } }
      )
    );
    // console.log(

    // );
    // if (!environment.base_url || environment.base_url.length == 0) {
    //   url = this.router.serializeUrl(
    //     this.router.createUrlTree(
    //       [`/pages/project/view-reservation/${reservationId}`],
    //       { queryParams: { ro: ro } }
    //     )
    //   );
    // } else {
    //   if (
    //     window.location.href.includes("https://staging2.fabrica-dev.com/castle")
    //   ) {
    //     url = `https://staging2.fabrica-dev.com/castle/pages/project/view-reservation/${reservationId}?ro=${ro}`;
    //   } else {
    //     url = `https://system.castle-development.com/pages/project/view-reservation/${reservationId}?ro=${ro}`;
    //   }
    // }
    // else{
    //   url = environment.base_url + `/pages/project/view-reservation/${reservationId}?ro=${ro}`
    // }
    window.open(url, "_blank");
  }

  searchLeads(keyword, searchBy: "lead" | "rfid" | "unit_serial") {
    return this.http.get(
      `${this.baseUrl}helpdesk/leads/search?keyword=${keyword}`,
      {
        params: {
          search_by: searchBy,
        },
      }
    );
  }

  deleteTicket(id) {
    return this.http.delete(`${this.baseUrl}helpdesk/tickets/${id}`);
  }

  getMeetingTypes(params?: any) {
    return this.http.get(`${this.baseUrl}meeting-types`, { params });
  }

  addMeetingType(payload) {
    return this.http.post(`${this.baseUrl}meeting-types`, payload);
  }

  editMeetingType(id, payload) {
    return this.http.put(`${this.baseUrl}meeting-types/${id}`, payload);
  }

  deleteMeetingType(id) {
    return this.http.delete(`${this.baseUrl}meeting-types/${id}`);
  }

  getEventTypes(params?: any) {
    return this.http.get(`${this.baseUrl}event-types`, { params });
  }

  getEventStatuses(params?: any) {
    return this.http.get(`${this.baseUrl}event-statuses`, { params });
  }

  addEventStatus(payload) {
    return this.http.post(`${this.baseUrl}event-statuses`, payload);
  }

  editEventStatus(id, payload) {
    return this.http.put(`${this.baseUrl}event-statuses/${id}`, payload);
  }

  deleteEventStatus(id) {
    return this.http.delete(`${this.baseUrl}event-statuses/${id}`);
  }

  getCallTypes(params?: any) {
    return this.http.get(`${this.baseUrl}call-types`, { params });
  }

  addCallType(payload) {
    return this.http.post(`${this.baseUrl}call-types`, payload);
  }

  editCallType(id, payload) {
    return this.http.put(`${this.baseUrl}call-types/${id}`, payload);
  }

  deleteCallType(id) {
    return this.http.delete(`${this.baseUrl}call-types/${id}`);
  }

  getMessageSources(params?: any) {
    return this.http.get(`${this.baseUrl}message-sources`, { params });
  }

  addMessageSource(payload) {
    return this.http.post(`${this.baseUrl}message-sources`, payload);
  }

  editMessageSource(id, payload) {
    return this.http.put(`${this.baseUrl}message-sources/${id}`, payload);
  }

  deleteMessageSource(id) {
    return this.http.delete(`${this.baseUrl}message-sources/${id}`);
  }

  getFeedbackStatuses(params?: any) {
    return this.http.get(`${this.baseUrl}feedback-statuses`, { params });
  }

  addFeedbackStatus(payload) {
    return this.http.post(`${this.baseUrl}feedback-statuses`, payload);
  }

  editFeedbackStatus(id, payload) {
    return this.http.put(`${this.baseUrl}feedback-statuses/${id}`, payload);
  }

  deleteFeedbackStatus(id) {
    return this.http.delete(`${this.baseUrl}feedback-statuses/${id}`);
  }

  activateLeadAction(action_type: string, id: number) {
    return this.http.put(`${this.baseUrl}${action_type}/${id}/activate`, {});
  }

  deactivateLeadAction(action_type: string, id: number) {
    return this.http.put(`${this.baseUrl}${action_type}/${id}/deactivate`, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/helpdesk/helpdesk.service.ts